import { render, staticRenderFns } from "./Partenaires.vue?vue&type=template&id=281fd6e8&"
import script from "./Partenaires.vue?vue&type=script&lang=js&"
export * from "./Partenaires.vue?vue&type=script&lang=js&"
import style0 from "./Partenaires.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports